import { CheckIcon, CopyIcon, MailCheckIcon } from "lucide-react";

import { Button, Modal, ModalFooter } from "@/modules/common/components";
import { toast } from "react-toastify";
import { useState } from "react";

interface UserCreatedModalProps {
  open: boolean;
  userEmail?: string;
  onClose: () => void;
}

const UserCreatedModal = ({ open, userEmail, onClose }: UserCreatedModalProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!userEmail) return;

    await navigator.clipboard.writeText(userEmail);
    toast.success("E-mail copiado!");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      title="Usuário cadastrado com sucesso!"
      description="Um código para redefinição de senha foi enviado para o e-mail do usuário:"
    >
      <div className="flex items-center gap-3 rounded-lg border border-ui-primary/20 bg-ui-hover px-4 py-3.5">
        <MailCheckIcon className="shrink-0 text-ui-primary" size={24} />
        <p className="text-[17px] font-bold text-ui-primary wrap-break-word">{userEmail}</p>

        <button
          type="button"
          onClick={handleCopy}
          aria-label="Copiar e-mail"
          className="shrink-0 cursor-pointer rounded-md p-1.5 text-ui-primary hover:bg-ui-primary/10"
        >
          {copied ? <CheckIcon size={18} /> : <CopyIcon size={18} />}
        </button>
      </div>

      <ModalFooter>
        <Button label="OK" className="w-full" onClick={onClose} />
      </ModalFooter>
    </Modal>
  );
};

export default UserCreatedModal;
